import { forwardRef } from 'react'
import { cn } from '@/lib/utils'

interface MaskedInputProps extends Omit<React.InputHTMLAttributes<HTMLInputElement>, 'onChange'> {
  value: string
  onChange: (raw: string) => void
  mask: (digits: string) => string
  strip: (value: string) => string
  maxRaw?: number
}

export const MaskedInput = forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ value, onChange, mask, strip, maxRaw, className, 'aria-invalid': ariaInvalid, ...props }, ref) => {
    const displayValue = mask(value)

    function handleChange(e: React.ChangeEvent<HTMLInputElement>) {
      const raw = strip(e.target.value)
      if (maxRaw !== undefined && raw.length > maxRaw) return
      onChange(raw)
    }

    return (
      <input
        ref={ref}
        {...props}
        value={displayValue}
        onChange={handleChange}
        aria-invalid={ariaInvalid}
        className={cn(
          'flex h-9 w-full rounded-md border border-input bg-background px-3 py-1 text-sm shadow-sm transition-colors',
          'placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring',
          'disabled:cursor-not-allowed disabled:opacity-50',
          ariaInvalid && 'border-destructive focus-visible:ring-destructive/50',
          className,
        )}
      />
    )
  },
)
MaskedInput.displayName = 'MaskedInput'
